import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as ArrowRightIcon } from './arrowRight.svg';

export const ArrowRight = IconHOC(ArrowRightIcon);
